/**
 *
 * @param {{arrayToBeSort:any[],sortKey:string}} param0
 * @returns {any[]}
 */
export const getSortedArray = ({ arrayToBeSort = [], sortKey = "" }) => {
  return arrayToBeSort?.sort((a, b) => a?.[sortKey] - b?.[sortKey]);
};

/**
 * Get filtered array
 * @param {{arrayToBeFilter:any[],filterKey:string,filterValidationString:string}} param0
 * @returns {any[]}
 */
export const getFilteredArray = ({
  arrayToBeFilter = [],
  filterKey = "",
  filterValidationString = "",
}) => {
  return arrayToBeFilter.filter(
    (f) =>
      f?.[filterKey] &&
      f?.[filterKey]?.toLowerCase() === filterValidationString?.toLowerCase()
  );
};
